export default {
  items: [],
  pagination: {},
  size: 30,
};
